module.exports = __webpack_public_path__ + "static/media/personal_icon.27e43005.svg";